module.exports = __webpack_public_path__ + "static/media/second_irwin_conference_center.b1639204.mp4";